module.exports = __webpack_public_path__ + "static/media/logo.220c798f.png";